<div
  class="inpage-search"
  [ngClass]="{
    'inpage-search__flex-column': flexDirection === 'column',
    'inpage-search--no-search-icon': CTA,
  }"
>
  <hdi-search
    [ngClass]="{
      'cta-mode': CTA,
      'inpage-search-item': padding,
      'inpage-search-item-no-padding': !padding,
    }"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [inpage]="true"
    [inpageCTA]="CTA"
    [hasError]="hasError"
    (handleInputChange)="inputChange($event)"
    (handleClearInput)="closeSearchResults()"
  ></hdi-search>
  <span *ngIf="hasError" class="inpage-search-error-message"
    >Bitte geben Sie mind. drei Zeichen ein.</span
  >

  <div class="inpage-search__auto-complete" *ngIf="!hasError && !isEmpty">
    <ul #resultContainer class="inpage-search__auto-complete-list">
      <span *ngIf="searchedElements.length === 0"
        >Keine Ergebnisse gefunden</span
      >
      <ng-container *ngIf="searchedElements.length > 0">
        <ng-container
          *ngFor="let section of searchedElements | groupBy: 'sectionHeadline'"
        >
          <div
            *ngIf="section.value"
            class="inpage-search__auto-complete-list-category"
          >
            <h5>{{ section.key }}</h5>
            <ng-container *ngFor="let item of section.value">
              <li *ngIf="item.label">
                <p
                  (click)="scrollToResult(item.anchor)"
                  [innerHTML]="item.label"
                  (keydown)="handleKeyDown($event, item.anchor)"
                ></p>
              </li>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </ul>
  </div>
</div>
